export const transition = {
    ease: [0.60, 0.60, 0.60, 0.60],
    duration: 0.30
};
